"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var UploadExport = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M5,13 L5,17 C5,17.5522847 5.44771525,18 6,18 L17,18 C17.5522847,18 18,17.5522847 18,17 L18,13 L19,13 L19,17 C19,18.1045695 18.1045695,19 17,19 L6,19 C4.8954305,19 4,18.1045695 4,17 L4,13 L5,13 Z M11,6.70710678 L8.85355339,8.85355339 C8.65829124,9.04881554 8.34170876,9.04881554 8.14644661,8.85355339 C7.95118446,8.65829124 7.95118446,8.34170876 8.14644661,8.14644661 L11.5,4.79289322 L14.8535534,8.14644661 C15.0488155,8.34170876 15.0488155,8.65829124 14.8535534,8.85355339 C14.6582912,9.04881554 14.3417088,9.04881554 14.1464466,8.85355339 L12,6.70710678 L12,16 L11,16 L11,6.70710678 Z" })));
};
UploadExport.displayName = 'UploadExport';
exports.default = UploadExport;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=UploadExport.js.map